import EditIcon from '@mui/icons-material/Edit';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import { FormulaContainer } from 'components/FormulaRenderer/formulas/FormulaParts';
import { isHtmlEmpty } from 'helpers/htmlHelpers';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import DataCatalogTextEditor from './DataCatalogTextEditor';

const FieldFormula = ({
    canEdit,
    formula: initialFormula,
    onSave,
}: {
    canEdit: boolean;
    formula?: string;
    onSave?: (value: string) => void;
}) => {
    const { t } = useTranslation();
    const [formula, setFormula] = useState(initialFormula ?? '');
    const [isEditable, setIsEditable] = useState(false);
    if ((!formula || isHtmlEmpty(formula)) && !canEdit) {
        return null;
    }
    return (
        <Box sx={{ mt: 4, mb: 4 }}>
            <Stack direction="row" sx={{ alignItems: 'center' }}>
                <Typography variant="h5" color="textPrimary">
                    {t('dataCatalog.formula')}
                </Typography>
                {canEdit && (
                    <IconButton onClick={() => setIsEditable(!isEditable)}>
                        <EditIcon color="primary" />
                    </IconButton>
                )}
            </Stack>
            <FormulaContainer>
                <DataCatalogTextEditor
                    isEditable={isEditable}
                    content={formula}
                    canEdit={canEdit}
                    onSave={(value) => {
                        setFormula(value);
                        setIsEditable(false);
                        onSave?.(value);
                    }}
                />
            </FormulaContainer>
        </Box>
    );
};

export default FieldFormula;
